import popularCarriersByInsuranceTypeSelector from './popularCarriersByInsuranceTypeSelector';
import { createSelector } from 'reselect';
import { insuranceTypeSelector } from '../insurance-type';

const popularCarriersSelector = createSelector(
    popularCarriersByInsuranceTypeSelector,
    insuranceTypeSelector,
    (popularCarriersByInsuranceType, insuranceType) => popularCarriersByInsuranceType[`${insuranceType}-all`]
);

export default popularCarriersSelector;
